import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { cn } from '../../lib/utils';

export function Breadcrumbs({ items, className }) {
  return (
    <nav 
      aria-label="Breadcrumb" 
      className={cn('flex items-center flex-wrap gap-1 text-sm', className)}
    >
      <Link 
        to="/" 
        className="flex items-center gap-1 text-[#4A4A4A] hover:text-[#FF6B35] transition-colors"
      >
        <Home className="w-4 h-4" />
        <span className="hidden sm:inline">Home</span>
      </Link>

      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-1">
          <ChevronRight className="w-4 h-4 text-[#4A4A4A]/50" />
          {item.href ? (
            <Link 
              to={item.href}
              className="text-[#4A4A4A] hover:text-[#FF6B35] transition-colors"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-[#1A1A1A] font-medium truncate max-w-[200px] sm:max-w-none">
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}
